var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_66872",
    "data-name": "Group 66872",
    transform: "translate(-1268 -367)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2378",
    "data-name": "Ellipse 2378",
    cx: 16,
    cy: 16,
    r: 16,
    transform: "translate(1268 367)",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "download_1_",
    "data-name": "download (1)",
    d: "M51.51,43.5a8,8,0,1,0,8,8A8.01,8.01,0,0,0,51.51,43.5ZM49.355,51.51a.469.469,0,0,1,.661-.072l1.025.822V47.447a.47.47,0,1,1,.94,0V52.26L53,51.438a.471.471,0,1,1,.59.733L51.8,53.609a.47.47,0,0,1-.59,0l-1.788-1.437A.47.47,0,0,1,49.355,51.51ZM54.9,55.652H48.122a.471.471,0,0,1,0-.941H54.9a.471.471,0,0,1,0,.941Z",
    transform: "translate(1232.49 331.498)",
    fill: "#929292",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.a40fa5d2616a1ee649c8af4b445babe7.svg";
export { ForwardRef as ReactComponent };